<p>group-biography works!</p>

<img src={{band.image}}>
{{band.biography}}